import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';

const SITE_URL = 'https://vigorbuy.courses';

const articleImages: Record<string, string> = {
  'article-guide-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20scene%20with%20a%20sleek%20laptop%20displaying%20organized%20spreadsheet%20data%20on%20screen%2C%20a%20steaming%20ceramic%20coffee%20mug%2C%20a%20notebook%20with%20handwritten%20notes%2C%20warm%20morning%20sunlight%20streaming%20through%20a%20window%2C%20soft%20natural%20shadows%2C%20cream%20and%20sand%20colored%20desk%20setup%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20calm%20productive%20atmosphere&width=800&height=600&seq=art-guide-v2&orientation=landscape',
  'article-hoodies-01': 'https://readdy.ai/api/search-image?query=Elegant%20flatlay%20photography%20of%20three%20cozy%20hoodies%20in%20sage%20green%2C%20oatmeal%20cream%2C%20and%20charcoal%20gray%20arranged%20on%20a%20light%20stone%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20editorial%20fashion%20catalog%20style%2C%20fabric%20texture%20visible%2C%20minimalist%20composition%2C%20warm%20neutral%20tones%2C%20professional%20product%20display&width=800&height=600&seq=art-hoodies-v1&orientation=landscape',
  'article-compare-01': 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20contrasting%20shopping%20experiences%2C%20left%20side%20showing%20a%20clean%20organized%20spreadsheet%20interface%20on%20a%20laptop%2C%20right%20side%20showing%20chaotic%20multiple%20browser%20tabs%2C%20soft%20warm%20lighting%2C%20editorial%20style%2C%20cream%20and%20sandstone%20color%20palette%2C%20professional%20photography%2C%20symbolic%20visual%20storytelling&width=800&height=600&seq=art-compare-v1&orientation=landscape',
  'article-categories-01': 'https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20of%20fashion%20and%20lifestyle%20products%20neatly%20arranged%20in%20labeled%20sections%20on%20a%20light%20oak%20wooden%20surface%2C%20sneakers%2C%20watches%2C%20bags%2C%20sunglasses%2C%20and%20accessories%20organized%20by%20category%2C%20soft%20natural%20window%20light%2C%20warm%20earthy%20tones%2C%20editorial%20catalog%20photography%2C%20clean%20minimalist%20aesthetic&width=800&height=600&seq=art-categories-v1&orientation=landscape',
  'article-compare-02': 'https://readdy.ai/api/search-image?query=Close%20up%20photography%20of%20a%20person%20using%20a%20tablet%20with%20a%20product%20comparison%20interface%20displaying%20multiple%20fashion%20items%20side%20by%20side%2C%20warm%20ambient%20lighting%2C%20soft%20cream%20background%2C%20modern%20lifestyle%20scene%2C%20editorial%20style%2C%20shallow%20depth%20of%20field%2C%20professional%20composition&width=800&height=600&seq=art-compare2-v1&orientation=landscape',
  'article-bags-01': 'https://readdy.ai/api/search-image?query=Stylish%20product%20photography%20of%20three%20premium%20bags%20including%20a%20leather%20backpack%2C%20a%20canvas%20messenger%20bag%2C%20and%20a%20minimalist%20tote%2C%20arranged%20on%20a%20warm%20terracotta%20toned%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20editorial%20fashion%20catalog%20style%2C%20rich%20texture%20details%2C%20elegant%20composition&width=800&height=600&seq=art-bags-v1&orientation=landscape',
  'article-tips-01': 'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20creative%20workspace%20with%20sticky%20notes%2C%20bullet%20journal%2C%20colorful%20markers%2C%20and%20a%20laptop%20showing%20a%20clean%20organized%20interface%2C%20warm%20natural%20light%20from%20a%20window%2C%20soft%20cream%20and%20sand%20background%2C%20cozy%20productive%20atmosphere%2C%20editorial%20style%2C%20inspirational%20learning%20concept&width=800&height=600&seq=art-tips-v1&orientation=landscape',
  'article-accessories-01': 'https://readdy.ai/api/search-image?query=Luxury%20product%20flatlay%20of%20elegant%20accessories%20including%20a%20minimalist%20watch%20with%20leather%20strap%2C%20classic%20aviator%20sunglasses%2C%20a%20thin%20gold%20chain%20necklace%2C%20and%20a%20leather%20cardholder%2C%20arranged%20on%20a%20soft%20sage%20green%20linen%20surface%2C%20warm%20diffused%20lighting%2C%20editorial%20jewelry%20photography%2C%20refined%20aesthetic&width=800&height=600&seq=art-accessories-v1&orientation=landscape',
  'article-fashion-01': 'https://readdy.ai/api/search-image?query=Artistic%20fashion%20moodboard%20concept%20with%20fabric%20swatches%2C%20outfit%20sketches%2C%20and%20product%20photos%20of%20coordinated%20clothing%20pieces%20arranged%20on%20a%20warm%20beige%20textured%20background%2C%20soft%20natural%20light%2C%20creative%20editorial%20style%2C%20fashion%20design%20inspiration%2C%20elegant%20composition&width=800&height=600&seq=art-fashion-v1&orientation=landscape',
  'article-clothing-01': 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20curated%20clothing%20rack%20with%20a%20denim%20jacket%2C%20white%20cotton%20tee%2C%20beige%20chinos%2C%20and%20canvas%20sneakers%20styled%20together%2C%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20editorial%20fashion%20catalog%2C%20lifestyle%20product%20display%2C%20minimalist%20aesthetic&width=800&height=600&seq=art-clothing-v1&orientation=landscape',
};

export default function ShoppingGuidePage() {
  const jsonLd = useMemo(() => ({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': `${SITE_URL}/shopping-guide#webpage`,
        'url': `${SITE_URL}/shopping-guide`,
        'name': 'Vigorbuy Shopping Guide - Expert Articles & Tutorials',
        'description': 'Expert articles and comprehensive guides to help you master the Vigorbuy Spreadsheet. Learn how to find products, compare options, and shop smarter.',
        'inLanguage': 'en-US',
        'isPartOf': {
          '@type': 'WebSite',
          '@id': `${SITE_URL}/#website`,
        },
        'about': 'Vigorbuy Spreadsheet shopping guides and tutorials',
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${SITE_URL}/shopping-guide#breadcrumb`,
        'itemListElement': [
          { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': SITE_URL },
          { '@type': 'ListItem', 'position': 2, 'name': 'Shopping Guide' },
        ],
      },
    ],
  }), []);

  return (
    <>
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-20">
        <section className="w-full bg-background-100/60 border-b border-background-200/50">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
            <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-foreground-700 transition-colors">Home</Link>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-600 font-medium">Shopping Guide</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Vigorbuy <span className="text-primary-500">Shopping Guide</span>
            </h1>
            <p className="mt-4 text-base md:text-lg text-foreground-500 max-w-2xl leading-relaxed">
              Expert articles and comprehensive guides to help you master the Vigorbuy Spreadsheet. Learn how to find products, compare options, and shop smarter.
            </p>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {allArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all duration-300 hover:border-primary-300/50 cursor-pointer flex flex-col"
                >
                  <div className="relative w-full h-[200px] bg-background-100 flex-shrink-0">
                    <img
                      src={articleImages[article.imageSeq] || articleImages['article-guide-01']}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full font-medium">
                        {article.category}
                      </span>
                      <span>{article.date}</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="mt-auto pt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600">
                      Read Article <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100/60">
          <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              Ready to Start Shopping?
            </h2>
            <p className="mt-3 text-base text-foreground-500 max-w-lg mx-auto">
              Browse all product categories and start discovering products today.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                vigorbuy sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-7 py-3 bg-foreground-950 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap"
              >
                Back to Homepage
                <i className="ri-home-4-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}